import { StatsigClient } from '@statsig/js-client';
import { runStatsigTriggeredSessionReplay } from '@statsig/session-replay';

const LOGGED_COHORTS_KEY = 'statsig_replay_cohorts_logged';

const unloggedCohorts = (client, cohorts) => {
  const sessionID = client.getContext?.()?.session?.data?.sessionID;

  if (!sessionID) { return cohorts; }

  try {
    const stored = JSON.parse(window.localStorage.getItem(LOGGED_COHORTS_KEY) || '{}');
    const logged = stored.sessionID === sessionID && Array.isArray(stored.cohorts) ? stored.cohorts : [];
    const pending = cohorts.filter((cohort) => !logged.includes(cohort));

    if (pending.length) {
      window.localStorage.setItem(
        LOGGED_COHORTS_KEY,
        JSON.stringify({ sessionID, cohorts: logged.concat(pending) })
      );
    }

    return pending;
  } catch (_err) {
    // Storage blocked or corrupt: log rather than drop the trigger that starts the recording.
    return cohorts;
  }
};

(async () => {
  const config = window.__STATSIG_CONFIG__;

  if (!config?.sessionReplay) { return; }

  const client = new StatsigClient(
    config.clientKey,
    {
      userID: config.userID,
      email: config.email,
      ...(config.customIDs && { customIDs: config.customIDs }),
      ...(config.custom && { custom: config.custom }),
    },
    {
      environment: { tier: config.tier },
      ...(config.initializeValues && { initializeValues: config.initializeValues }),
      networkConfig: {
        initializeUrl: 'https://featureassets.org/v1/initialize',
        logEventUrl: 'https://prodregistryv2.org/v1/rgstr',
      },
    }
  );

  runStatsigTriggeredSessionReplay(client, {
    autoStartRecording: false,
    keepRollingWindow: true,
  });

  try {
    await client.initializeAsync();
  } catch (_err) {
    // Statsig initialization failure is non-critical; session replay will not run.
    return;
  }

  // After init, so the trigger config has arrived.
  unloggedCohorts(client, config.sessionReplayCohorts || []).forEach((cohort) => {
    client.logEvent('session_replay_cohort', cohort);
  });
})();
